<template>
  <footer>
    <p><b>Data Source: </b>
      <a
        href="https://www.iqair.com/us/air-pollution-data-api"
        target="_blank"
        rel="noreferrer">
        IQAir Air Quality API
      </a>
    </p>
    <p><b>Built By: </b>Tashia Davis, Alia Peterson, and Allison Dietz.
      <a
        href="https://github.com/alia-peterson/ActivAir"
        target="_blank"
        rel="noreferrer">
        View Repo on GitHub
      </a>
    </p>
  </footer>
</template>

<script>export default { name: 'Footer' }</script>

<style src='./Footer.css'></style>
